import React, { useEffect, useMemo } from 'react';
import Phase5ReportView from './Phase5ReportView';
import { Phase5ReportSection } from './Phase5ReportSystem';
import { getPhase5SectionId } from '../utils/phase5ReportUi';

const withStableIds = (sections) => {
  const occurrences = new Map();
  return sections.map((section) => {
    const title = String(section.title || 'Section');
    const occurrence = occurrences.get(title) || 0;
    occurrences.set(title, occurrence + 1);
    return { ...section, id: section.id || getPhase5SectionId(title, occurrence) };
  });
};

function ControlledRecommendationSections({ sections, expandedSectionIds, onExpandedSectionIdsChange, onSectionIdsChange }) {
  const registered = useMemo(() => withStableIds(sections), [sections]);
  const ids = useMemo(() => registered.map(({ id }) => id), [registered]);
  useEffect(() => { onSectionIdsChange(ids); }, [ids, onSectionIdsChange]);
  return <div className="phase5-report helpful-resource-report phase5-recommendation-report mt-4">
    {registered.map((section, index) => {
      const expanded = expandedSectionIds.includes(section.id);
      return <Phase5ReportSection key={section.id} index={index} title={section.title} expanded={expanded}
        onToggle={() => onExpandedSectionIdsChange(expanded
          ? expandedSectionIds.filter((id) => id !== section.id)
          : [...expandedSectionIds, section.id])}
        testId={section.testId}>
        {section.body}
      </Phase5ReportSection>;
    })}
  </div>;
}

export default function RecommendationReportRenderer({ sessionId, reportKey, reportName, sections, testId }) {
  const available = Array.isArray(sections) ? sections.filter(Boolean) : [];
  return <div data-testid={testId}>
    <Phase5ReportView sessionId={sessionId} reportKey={reportKey} reportName={reportName}>
      {(controls) => <ControlledRecommendationSections sections={available} {...controls} />}
    </Phase5ReportView>
  </div>;
}
